import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';

import ModalWrapper from '../../../../components/RootModal/ModalWrapper';
import { ReactComponent as IconAvatar } from '../../../../assets/imgs/icon-avatar.svg';
import AddUserForm from './AddUserForm';
import sanitizePhoneNumber from '../../../../utilities/sanitizePhoneNumber';
import displayPhoneNumber from '../../../../utilities/displayPhoneNumber';
import activateItem from '../../../../utilities/activateItem';

class AddUserModal extends Component {
  isUK = () => (process.env.REACT_APP_STAGE === 'uk');
  isCleverOrg = this.props.organization && (!!this.props.organization.cleverData || !!this.props.organization.cleverItem);

  handleAddNewUser = async (values) => {
    let isDesignatedValue = undefined;

    if (values.isDesignated !== undefined) {
      if (values.isDesignated === true) {
        isDesignatedValue = "1";
      }
      else if (values.isDesignated === false) {
        isDesignatedValue = "0";
      }
    }

    const user = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phoneNumber: sanitizePhoneNumber(values.phoneNumber),
      role: this.props.role,
      isDesignated: isDesignatedValue,
    };

    console.log('user:', user);

    if (this.props.role !== 'tm_admin' && this.props.organization.orgId) {
      user.orgId = this.props.organization.orgId;
    }

    if (this.props.isUserProfile && values.password && values.password.length > 0) {
      user.password = values.password;
    }

    if (this.isCleverOrg && this.props.user && this.props.user.cleverData) {
      const cleverUser = {
        id: (values.searchUser && values.searchUser[0].sub) || this.props.user.sub,
        ...(this.props.user.orgId && { orgId: this.props.user.orgId }),
        isActivated: values.isActivated,
        type: 'user'
      };
      // process clever user update
      await activateItem(cleverUser, this.props.idToken);
      this.props.listUsers();
      this.props.closeModal();

      // exit early
      return;
    }

    if (this.props.user) {
      this.props.addUser(this.props.user.username, user, this.props.isUserProfile);
    } else {
      this.props.addUser(user);
    }
  };

  render() {
    console.log('add user modal props: ', this.props);
    const initialValues = {};
    if (this.props.user) {
      initialValues.firstName = this.props.user.firstName;
      initialValues.lastName = this.props.user.lastName;
      initialValues.email = this.props.user.email;
      if (this.props.user.phoneNumber) {
        initialValues.phoneNumber = displayPhoneNumber(this.props.user.phoneNumber);
      }
      if (this.props.role === 'district_champion' && this.props.user.isDesignated) {
        initialValues.isDesignated = this.props.user.isDesignated === "1" ? true : false;
      }
      if (this.props.user.isActivated) {
        initialValues.isActivated = this.props.user.isActivated;
      }
    }

    let createButtonText = 'Add User';
    let titleText = this.props.user ? 'Edit User' : 'Add New User';
    let labelText = 'User';

    if (this.props.role && this.props.role === 'district_champion') {
      createButtonText = `Add ${this.isUK() ? 'Group' : 'Organization'} Champion`;
      titleText = this.props.user ? `Edit ${this.isUK() ? 'Group' : 'Organization'} Champion` : `Add ${this.isUK() ? 'Group' : 'Organization'} Champion`;
      labelText = `${this.isUK() ? 'Group' : 'Organization'} Champion`;
    }

    if (this.props.role && this.props.role === 'school_champion') {
      createButtonText = `Add ${this.isUK() ? 'Organisation' : 'Group'} Champion`;
      titleText = this.props.user ? `Edit ${this.isUK() ? 'Organisation' : 'Group'} Champion` : `Add ${this.isUK() ? 'Organisation' : 'Group'} Champion`;
      labelText = `${this.isUK() ? 'Organisation' : 'Group'} Champion`;
    }

    // When Editing your own profile
    if (this.props.isUserProfile) {
      titleText = 'Edit your profile';
      createButtonText = 'Save Edits';
      labelText = 'User';
    }

    return (
      <ModalWrapper show={this.props.show} resetModalErrorsOnClose={true}>
        <Modal.Header closeButton>
          <Modal.Title>
            <IconAvatar style={{ marginRight: '1rem' }} />
            {titleText}
          </Modal.Title>
        </Modal.Header>
        <div style={{ flex: 1, alignItems: 'center' }}>
          {typeof this.props.error === 'string' ? <span className="error" style={{ textAlign: 'center' }}>{this.props.error}</span> : null}
        </div>
        <Modal.Body bsPrefix="modalContent">
          <AddUserForm
            onSubmit={this.handleAddNewUser}
            initialValues={initialValues}
            labelText={labelText}
            organization={this.props.organization}
            saveButtonText={this.props.user ? 'Save Edits' : createButtonText}
            closeModal={this.props.closeModal}
            isUserProfile={this.props.isUserProfile}
            item={this.props.user}
            showDesignatedToggle={this.props.role === 'district_champion' && !this.props.isUserProfile ? true : false}
            isCleverOrg={this.isCleverOrg}
            idToken={this.props.idToken}
          />
        </Modal.Body>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    role: state.auth.role,
    organization: state.organizations.organization,
    error: state.users.error,
    idToken: state.auth.idToken,
  };
};

export default connect(mapStateToProps)(AddUserModal);
